import React from 'react'
import Grey from '../grey'
import Text from '../text'
import Keen from '../keen'
import styled from 'styled-components'

const Container = styled.div`
  padding-top: 150px;
  background-color: #fff;
  @media(max-width: 768px) {
    padding-top: 25px;
  }
`

const PastEditions = ({past_editions}) => {
  const images = past_editions.map((p, index) => {
    return ({
      asset: {
        publicUrl: p.mainImage.asset.publicUrl,
        title: p.title,
        link: p.slug.current
      }
    })
  });
  const module = {
    background_grey: true,
    images: images
  }
  return (
    <Container>
      <Grey>
        <div>
        <Text mb0>
          <h2>Where We've Come From</h2>
          <h3>Past Editions</h3>
        </Text>
        <Keen module={module} />
        </div>
      </Grey>
    </Container>
  )
}

export default PastEditions;
